<kl-loading *ngIf="showLoading" [loadingText]="loadingText"></kl-loading>
<div
  class="col-sm-12 col-md-12 p-0"
  *ngIf="report_type === ReportTypeEnum.GRID"
>
  <kl-report-toolbar
    [gridHeaderName]="gridHeaderName | translate"
    [fullscreen]="true"
    [alertType]="alertType"
    [materialTransactionExtract]="
      ReportTypeEnum.GRID && showMaterialExtractButton
    "
    [alertShow]="alertShow"
    [alertMessage]="alertMessage"
    (onCloseAlert)="alertShow = false"
    (onMaterialTransactionExtract)="getMaterialTransactionExtract()"
    (onFieldsOpen)="filedsOpen()"
    (onPrint)="onPrint()"
    (onTemplateOpen)="templateOpen()"
    (onRefresh)="reload()"
    (onExport)="export($event)"
  >
  </kl-report-toolbar>
</div>
<div
  class="pivot-container"
  *ngIf="report_type === ReportTypeEnum.PIVOT && showPivot"
>
  <ejs-pivotview
    #syncPivot
    allowExcelExport="true"
    allowNumberFormatting="true"
    width="100%"
    [locale]="localeCulture"
    [height]="height"
    class="pivot-grid"
    allowConditionalFormatting="true"
    allowPdfExport="true"
    showToolbar="true"
    allowCalculatedField="true"
    showFieldList="true"
    (saveReport)="saveReport($event)"
    (loadReport)="loadReport($event)"
    (fetchReport)="fetchReport($event)"
    (renameReport)="renameReport($event)"
    (removeReport)="removeReport($event)"
    (enginePopulated)="afterEnginePopulate($event)"
    [dataSourceSettings]="dataSourceSettings"
    [gridSettings]="gridSettings"
    [toolbar]="toolbarOptions"
  >
  </ejs-pivotview>
</div>
<div
  class="grid-container"
  *ngIf="report_type === ReportTypeEnum.GRID && showGrid"
>
  <p-sidebar
    [(visible)]="showFieldPanel"
    position="right"
    styleClass="kl-sidebar"
    (onHide)="showFieldPanel = false"
  >
    <div class="sidebar-header">
      <label>{{ "column_add_or_remove" | translate }}</label>
    </div>
    <kl-column-picker
      *ngIf="showFieldPanel"
      [flexGrid]="flexGrid"
    ></kl-column-picker>
  </p-sidebar>
  <wj-flex-grid
    #klReportFlexGrid
    style="max-height: calc(100vh - 175px)"
    (initialized)="initializeGrid(klReportFlexGrid)"
    [itemsSource]="gridCollectionView"
    [selectionMode]="'Row'"
    [isReadOnly]="true"
    [autoGenerateColumns]="false"
    [deferResizing]="true"
  >
    <wj-flex-grid-filter
      #flexGridFilterEl
      (editingFilter)="editingFilter(flexGridFilterEl, $event)"
      (filterChanged)="onFilterChanged()"
    ></wj-flex-grid-filter>

    <wj-flex-grid-column
      *ngFor="let column of columns"
      [header]="column.header | translate"
      [format]="column.format"
      [aggregate]="column.aggregate ? column.aggregate : 'None'"
      [align]="column.align"
      [visible]="column.visible"
      [binding]="column.binding"
      [format]="
        column.format
          ? column?.format === 'date'
            ? utilService.dateFormatString
            : column?.format === 'date-time'
            ? utilService.dateFormatString + ' HH:mm:ss'
            : column.format
          : ''
      "
      [width]="column?.width ? column?.width : '*'"
    >
      <ng-template
        wjFlexGridCellTemplate
        [cellType]="'Cell'"
        let-cell="cell"
        *ngIf="column.date"
      >
        {{ cell.item[column.binding] | klDate }}
      </ng-template>

      <ng-template
        *ngIf="column?.format === 'date'"
        wjFlexGridCellTemplate
        [cellType]="'Cell'"
        let-cell="cell"
      >
        {{ getValue(cell.item, column.binding) | klDate }}
      </ng-template>
      <ng-template
        *ngIf="column?.format === 'date-time'"
        wjFlexGridCellTemplate
        [cellType]="'Cell'"
        let-cell="cell"
      >
        {{ getValue(cell.item, column.binding) | klDate : true }}
      </ng-template>
      <ng-template
        *ngIf="column?.format === 'time'"
        wjFlexGridCellTemplate
        [cellType]="'Cell'"
        let-cell="cell"
      >
        {{
          stringTimeConvert(cell.item[column.binding]) | klDate : false : true
        }}
      </ng-template>
      <ng-template
        *ngIf="column?.format === 'image'"
        wjFlexGridCellTemplate
        [cellType]="'Cell'"
        let-cell="cell"
        class="p-0 m-0"
      >
        <img
          src="{{ 'data:image/jpeg;base64,' + cell.item[column.binding] }}"
          alt="{{ cell.item['description'] }}"
          class="grid-column-image"
        />
      </ng-template>
      <ng-template
        *ngIf="column?.format === 'string'"
        wjFlexGridCellTemplate
        [cellType]="'Cell'"
        let-cell="cell"
      >
        {{ convertString(cell.item[column.binding]) }}
      </ng-template>

      <ng-template
        wjFlexGridCellTemplate
        [cellType]="'Cell'"
        let-cell="cell"
        *ngIf="column.translate"
      >
        {{ cell.item[column.binding] | translate }}
      </ng-template>
    </wj-flex-grid-column>
  </wj-flex-grid>
</div>
<div
  class="sheet-container"
  *ngIf="report_type === ReportTypeEnum.EXCEL_SHEET && data"
>
  <kl-flex-sheet
    [columns]="columns"
    [data]="data"
    [gridName]="moduleName"
  ></kl-flex-sheet>
</div>
<p-sidebar
  [(visible)]="showTemplatePanel"
  position="right"
  styleClass="kl-sidebar position-fixed"
  (onHide)="showTemplatePanel = false"
>
  <div class="sidebar-header">
    <label>{{ "grid_design" | translate }}</label>
  </div>
  <a
    role="button"
    class="dropdown-item f-s-14 mt-1 mb-1"
    (click)="setDefaultTemplate()"
  >
    <i class="fa fa-columns" style="color: #9e9e9e" aria-hidden="true"></i>
    {{ "default_design" | translate }}
  </a>
  <a
    role="button"
    class="dropdown-item f-s-14 mt-1 mb-1"
    (click)="saveLayout('add')"
  >
    <i class="fa fa-save" style="color: #9e9e9e" aria-hidden="true"></i>
    {{ "save_design" | translate }}
  </a>
  <accordion style="padding-top: 0">
    <accordion-group
      [isOpen]="isTemplatesOpen"
      (isOpenChange)="isTemplatesOpen = $event"
      [panelClass]="'template-accordion'"
    >
      <div accordion-heading class="clearfix timeline-accordion-header">
        <i class="kalem-icon-buying md"></i
        ><span class="accordion-title">{{ "saved_designs" | translate }} </span>
      </div>
      <div style="overflow-y: auto; max-height: 350px">
        <ul class="timeline">
          <li
            *ngFor="let template of templates; let i = index"
            [class.active]="template.id === currentTemplate?.id"
          >
            <a
              role="button"
              class="dropdown-item position-relative"
              (click)="selectLayout(template, i)"
            >
              {{ template.description }}
            </a>
            <span
              *ngIf="showTemplateActionButton(template)"
              class="process-icons"
            >
              <i
                class="fa fa-edit template-process text-success"
                (click)="saveLayout('edit', template, i)"
              ></i>
              <i
                class="fa fa-trash template-process text-danger"
                (click)="deleteLayout(template, i)"
              ></i>
            </span>
          </li>
        </ul>
      </div>
    </accordion-group>
  </accordion>
</p-sidebar>
<kl-preference-form (onSetPreference)="commitSave($event)"></kl-preference-form>
